"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _emotion = require("emotion");

var root = function root() {
  return (
    /*#__PURE__*/
    (0, _emotion.css)("position:relative;")
  );
}; // margin-top: -4px;


var content = function content(theme, contentVisible) {
  return (
    /*#__PURE__*/
    (0, _emotion.css)("position:absolute;z-index:1;> [data-type=\"main\"]{margin-top:-24px;z-index:1;border-radius:4px;padding:11px 13px;font-size:13px;box-sizing:border-box;color:", theme.color.white, ";background-color:", theme.color.black1, ";}> [data-type=\"arrow\"]{z-index:0;width:8px;height:8px;background-color:", theme.color.black1, ";position:absolute;top:-4px;right:108px;margin-top:-24px;transform:rotate(45deg);}&[data-side=\"left\"] > [data-type=\"arrow\"]{}&[data-side=\"right\"] > [data-type=\"arrow\"]{top:50%;margin-top:-4px;left:-4px;}&[data-side=\"top\"] > [data-type=\"arrow\"]{left:50%;margin-left:-4px;bottom:-4px;}&[data-side=\"bottom\"] > [data-type=\"arrow\"]{left:50%;margin-left:-4px;top:-4px;}", contentVisible && "\n    display: block;\n  ")
  );
};

var _default = {
  root: root,
  content: content
};
exports.default = _default;